import img from '../../../assets/images/innerProductBanner.png';

function TrylayoutBanner({ currentProduct, onTryNowClick, children }) {
  return (
    <div className="landingMainSection InnerProductMainBanner position-relative bg-white p-3 p-lg-5 br_10 mt-2 w-100 mx-auto overflow-hidden">
      <img src={img} className="w-100 h-100 position-absolute top-0 start-0" />
      {children}
    </div>
  );
}

export default TrylayoutBanner;
